import { render, staticRenderFns } from "./BasseVision.vue?vue&type=template&id=116e4cb0"
import script from "./BasseVision.vue?vue&type=script&lang=js"
export * from "./BasseVision.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports